export const getCV = ({ cv }) => cv;
